import { render } from "./WhyWeChoose.vue?vue&type=template&id=ec3c109e"
const script = {}

import "./WhyWeChoose.vue?vue&type=style&index=0&id=ec3c109e&lang=css"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__